import { GQLSortOrder, GQLVehicleSort } from "@src/graphql.apollo.generated";
import { useIntl } from "react-intl";

import { ReactSelectOptions } from "../../../types";
import { ISort } from "./ISort";

export const useSortOptions = () => {
    const intl = useIntl();

    const sortOptions: ReactSelectOptions<ISort>[] = [
        {
            value: { sort: GQLVehicleSort.rate, sortOrder: GQLSortOrder.ASC },
            label: intl.formatMessage({
                id: "leaseme.sortOptions.rate.asc",
                defaultMessage: "Rate aufsteigend",
            }),
        },
        {
            value: { sort: GQLVehicleSort.rate, sortOrder: GQLSortOrder.DESC },
            label: intl.formatMessage({
                id: "leaseme.sortOptions.rate.desc",
                defaultMessage: "Rate absteigend",
            }),
        },
        {
            value: {
                sort: GQLVehicleSort.fuelConsumption,
                sortOrder: GQLSortOrder.ASC,
            },
            label: intl.formatMessage({
                id: "leaseme.sortOptions.fuelConsumption.asc",
                defaultMessage: "Verbrauch aufsteigend",
            }),
        },
        {
            value: {
                sort: GQLVehicleSort.fuelConsumption,
                sortOrder: GQLSortOrder.DESC,
            },
            label: intl.formatMessage({
                id: "leaseme.sortOptions.fuelConsumption.desc",
                defaultMessage: "Verbrauch absteigend",
            }),
        },
        {
            value: {
                sort: GQLVehicleSort.firstRegistration,
                sortOrder: GQLSortOrder.ASC,
            },
            label: intl.formatMessage({
                id: "leaseme.sortOptions.firstRegistration.asc",
                defaultMessage: "Erstzulassung aufsteigend",
            }),
        },
        {
            value: {
                sort: GQLVehicleSort.firstRegistration,
                sortOrder: GQLSortOrder.DESC,
            },
            label: intl.formatMessage({
                id: "leaseme.sortOptions.firstRegistration.desc",
                defaultMessage: "Erstzulassung absteigend",
            }),
        },
        {
            value: {
                sort: GQLVehicleSort.mileage,
                sortOrder: GQLSortOrder.ASC,
            },
            label: intl.formatMessage({
                id: "leaseme.sortOptions.mileage.asc",
                defaultMessage: "Kilometer aufsteigend",
            }),
        },
        {
            value: {
                sort: GQLVehicleSort.mileage,
                sortOrder: GQLSortOrder.DESC,
            },
            label: intl.formatMessage({
                id: "leaseme.sortOptions.mileage.desc",
                defaultMessage: "Kilometer absteigend",
            }),
        },
        {
            value: {
                sort: GQLVehicleSort.powerPS,
                sortOrder: GQLSortOrder.ASC,
            },
            label: intl.formatMessage({
                id: "leaseme.sortOptions.powerPS.asc",
                defaultMessage: "Leistung aufsteigend",
            }),
        },
        {
            value: {
                sort: GQLVehicleSort.powerPS,
                sortOrder: GQLSortOrder.DESC,
            },
            label: intl.formatMessage({
                id: "leaseme.sortOptions.powerPS.desc",
                defaultMessage: "Leistung absteigend",
            }),
        },
    ];

    return sortOptions;
};
